import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Nhúng font Roboto (hỗ trợ đầy đủ dấu tiếng Việt) — tránh hiện □□□.
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { App } from './App';

const container = document.getElementById('app');
if (!container) {
  throw new Error('Không tìm thấy phần tử #app trong index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
